<template>
	<section class="page page-signup">
		<SceneSignup />
	</section>
</template>

<script lang="ts">
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageSignup extends PageBase {
		// Not implemented
	}
</script>

<style lang="scss">
	[page='PageSignup'] #GlobalHeader,
	[page='PageSignup'] #GlobalNavigationTabs,
	[page='PageSignup'] .newfeature-coach-marks {
		display: none;
	}

	#app .page-signup {
		bottom: 0;
	}
</style>
